
import classes from './Button.module.css';

const Button = (props) => {
    const buttonClasses = `${classes.button} ${props.className || ''}`;

    return <button {...props} className={buttonClasses} >{props.children}</button>
};

export default Button;